import { bidBoardAuthHeaders, signedInBidUserId } from './bidBoardAuth';
let lastSent = 0, lastUser = '';
/** Receives real GPS fixes from existing watches; never asks for location or simulates it. */
export async function reportFormPresence(fix: {lat:number;lng:number;accuracy:number|null;timestamp:number}, force=false) {
  const user = signedInBidUserId();
  if (!user || fix.accuracy == null || fix.accuracy>150 || !Number.isFinite(fix.timestamp) || Date.now()-fix.timestamp>120000) return;
  if (!force && user===lastUser && Date.now()-lastSent<60000) return;
  lastSent=Date.now();lastUser=user;
  try {
    const response=await fetch('/api/form-map-presence',{method:'POST',headers:{...bidBoardAuthHeaders(),'Content-Type':'application/json'},
      body:JSON.stringify({latitude:fix.lat,longitude:fix.lng,accuracy:fix.accuracy,capturedAt:new Date(fix.timestamp).toISOString()})});
    if(!response.ok)lastSent=0;
  } catch {lastSent=0;}
}
